<template>
  <v-layout
    :row="!mobileView"
    :justify-start="!mobileView"
    :column="mobileView"
    align-center
    class="fill-width">
    <div :class="{'ml-2': !mobileView}">
      <img :src="picture" :alt="`Foto de ${student.name}`" class="image-circle">
    </div>

    <v-layout column :class="['fill-width', {'ml-3': !mobileView}]">
      <div class="fill-width display-1 mt-2 text-truncate text-xs-center text-md-left">
        {{ student.name }}
      </div>
      <span :class="['text-xs-center', 'text-md-left', { 'my-2': mobileView }]">
        <router-link v-show="showRedirectButton" :to="redirectPath">
          Selecione outro filho
        </router-link>
      </span>
    </v-layout>
  </v-layout>
</template>

<script>
import { mobileViewBreakpoint } from '@/helpers/mobileViewBreakpoint'
/**
 * @group Meal Control
 * Estrutura de campos com dados dos estudantes alocados principalmente
 * na view StudentTrays. A principal função é gerir a troca de estudantes
 * entre as views.
 */
export default {
  name: 'StudentFields',

  props: {
    // Dados do estudante que será exibido
    student: {
      type: Object,
      // {}
      default () { return {} }
    },
    // Path de direcionamento para a view de seleção de estudantes
    redirectPath: {
      type: String,
      default: ''
    }
  },

  computed: {
    picture () {
      return this.student.picture_path || require('@/assets/images/placeholders/user.png')
    },

    showRedirectButton () {
      return this.redirectPath
    },

    mobileView () {
      return mobileViewBreakpoint(this.$vuetify.breakpoint.name)
    }
  }
}
</script>
